import { c as _c } from "react/compiler-runtime";
import { Status } from '@systemeio/components';
import { InvoiceStateColor, InvoiceStateEnum, InvoiceStateTitle } from 'modules/payment/invoices/enums/invoice-state-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export const AffiliateInvoiceState = t0 => {
  const $ = _c(6);
  const {
    state
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const t1 = InvoiceStateColor[state];
  const t2 = InvoiceStateTitle[state];
  let t3;
  if ($[0] !== t || $[1] !== t2) {
    t3 = t(t2);
    $[0] = t;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t3) {
    t4 = <Status color={t1}>{t3}</Status>;
    $[3] = t1;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};